// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"f635f9ed","318":"39afcb18","412":"28d0f3b5","483":"bb278166","785":"ef13d4e3","998":"992bce51"}[chunkId] + ".chunk.js";
};